import axios from 'axios'
import { v4 as uuidv4 } from 'uuid'

import filesService from '@/services/files.service'

import { FilesActionTypes } from './action_types'
import { FilesMutationTypes } from './mutation_types'
import { FilesState } from './state'

type GetFilePayload = { mnemo: string; id: number }
type GetWatermarkedFilePayload = { mnemo: string; fileId: number; data: any }

export const actions: StoreActions<FilesActionTypes, FilesMutationTypes> = {
  async [FilesActionTypes.GET_FILE](
    { commit, state },
    { mnemo, id }: GetFilePayload,
  ) {
    commit(FilesMutationTypes.SET_FILE_PENDING, id)
    try {
      const { data } = await filesService.getFile(mnemo, id)
      return data
    } catch (error) {
      commit(FilesMutationTypes.SET_FILE_ERROR, error)
      throw error
    } finally {
      commit(FilesMutationTypes.REMOVE_FILE_PENDING, (state as FilesState)['filePendingIds'].indexOf(id))
    }
  },

  async [FilesActionTypes.GET_WATERMARKED_FILE](
    { state, commit },
    { mnemo, fileId, data }: GetWatermarkedFilePayload,
  ) {
    const identifier = uuidv4()
    commit(FilesMutationTypes.SET_WATERMARKED_FILE_PENDING, { fileId, data, identifier })
    try {
      const identifiedRequest = {
        identifier,
        cancelToken: null,
      }
      commit(FilesMutationTypes.SET_WATERMARKED_REQUEST_PENDING, identifiedRequest)
      const response = await filesService.getFileViewerInfo(mnemo, fileId, data, identifiedRequest)
      if ((state as FilesState)['watermarkedFile'].fileId === fileId && (state as FilesState)['watermarkedDialogData'].isOpen) {
        commit(FilesMutationTypes.SET_WATERMARKED_FILE, response.data)
      } else if (!(state as FilesState)['watermarkedFile'].fileId) {
        commit(FilesMutationTypes.RESET_WATERMARKED_FILE_WITH_FILE_ID, fileId)
        commit(FilesMutationTypes.SET_WATERMARKED_FILE, response.data)
      }
    } catch (error) {
      if (!axios.isCancel(error)) {
        commit(FilesMutationTypes.SET_WATERMARKED_FILE_ERROR, error)
        throw error
      }
    } finally {
      commit(FilesMutationTypes.REMOVE_WATERMARKED_FILE_PENDING, identifier)
      commit(FilesMutationTypes.REMOVE_WATERMARKED_REQUEST_PENDING, identifier)
    }
  },

  [FilesActionTypes.CANCEL_ALL_WATERMARKED_REQUEST_PENDING](
    { state, commit },
  ) {
    (state as FilesState).watermarkedRequestPending.forEach((req: any) => {
      req.cancelToken?.cancel()
      commit(FilesMutationTypes.RESET_WATERMARKED_FILE)
      commit(FilesMutationTypes.REMOVE_WATERMARKED_REQUEST_PENDING, req.identifier)
    })
  },
}
